import { action, observable } from 'mobx'
// Request
// Current user
import { SameDocumentRequest } from '../requests/SameDocumentRequest'

class SameDocumentStore {
  @action setFilter = (filterName, filterValue) => {
    if (typeof filterName !== 'string') return
    this[filterName] = filterValue
  }

  /** Incoming Document */

  // Lưu data văn bản
  @observable dataSameDocument = undefined

  @action setDataSameDocument = data => {
    this.dataSameDocument = data
  }

  @action clearDataSameDocument = () => {
    this.dataSameDocument = undefined
  }

  @action getDocumentsIncoming = param => {
    return new Promise((resolve, reject) => {
      SameDocumentRequest.getDocumentsIncoming(param)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }
  @action getDocumentsOutgoing = param => {
    return new Promise((resolve, reject) => {
      SameDocumentRequest.getDocumentsOutgoing(param)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  @action getDocumentsIncomingById = docId => {
    return new Promise((resolve, reject) => {
      SameDocumentRequest.getDocumentsIncomingById(docId)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  @action login = data => {
    return new Promise((resolve, reject) => {
      SameDocumentRequest.login(data)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  @action reload = params => {
    return new Promise((resolve, reject) => {
      SameDocumentRequest.reload(params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  @action reloadIncoming = data => {
    return new Promise((resolve, reject) => {
      SameDocumentRequest.reloadIncoming(data)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }
  @action updateReceivedStatus = data => {
    return new Promise((resolve, reject) => {
      SameDocumentRequest.updateReceivedStatus(data)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }
}

export default new SameDocumentStore()
